import _             from 'underscore';
import React, { FC } from 'react';

import { SelectField }              from '../formik';
import { capitalize, formatOption } from '../../../../util';
import { PreSelectedSelectField }   from '../../../../types';
import { LangService }              from '../../../../services';
import { DEFAULT_TERM_DICTIONARY }  from '../../../../lang/termDictionaries';

interface DictionaryTermKeyDropdownProps extends PreSelectedSelectField {
	termDictionary?: object,
	topSectionKeys?: string[],
}

const defaultProps: DictionaryTermKeyDropdownProps = {
	termDictionary: DEFAULT_TERM_DICTIONARY,
	topSectionKeys: null
}

const DictionaryTermKeyDropdown: FC<DictionaryTermKeyDropdownProps> = ( props ) => {
	
	let { termDictionary, topSectionKeys } = props,
	    dictionarySections                 = _.isArray( topSectionKeys ) ? _.pick( termDictionary, topSectionKeys ) : termDictionary;
	
	let options = LangService.getDictionaryPaths( dictionarySections ).map( path => {
		
		let pathParts = path.split( LangService.PATH_SEPARATOR ),
		    group     = pathParts.shift().split( LangService.KEY_SPACE_SEPARATOR ).join( ' ' ),
		    groupName = capitalize( group.toLowerCase() );
		
		return {
			...formatOption( path, [ group, ...pathParts ].join( ' : ' ), { group: groupName } ),
			content: pathParts.join( ' : ' )
		};
	} );
	
	return (
		<SelectField
			placeholder={ 'Choose a term key...' }
			useGroupNames={ true }
			style={ {
				wordBreak: 'break-word',
				fontSize:  12
			} }
			{ ..._.omit( props, _.keys( defaultProps ) ) }
			options={ options }>
		</SelectField>
	);
};

DictionaryTermKeyDropdown.defaultProps = defaultProps;

export { DictionaryTermKeyDropdown }
